type Props = {
  message: string
  onRetry?: () => void
}

export function RequestLoadError({ message, onRetry }: Props) {
  return (
    <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm flex items-center justify-between gap-3">
      <span>⚠ {message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-2 py-1 bg-white border border-red-300 rounded text-red-700 hover:bg-red-100 text-xs"
        >
          Повторить
        </button>
      )}
    </div>
  )
}
